import { createSvgIcon } from "@mui/material";

export const Icon = createSvgIcon(
  <>
    <path d="M12,23c-6.07,0-11-4.93-11-11S5.93,1,12,1s11,4.93,11,11-4.93,11-11,11ZM12,3C7.04,3,3,7.04,3,12s4.04,9,9,9,9-4.04,9-9S16.96,3,12,3Z" />
    <path d="M7.66,15.68c2.57,2.57,6.73,2.57,9.3,0,.91-.91,1.49-2.03,1.75-3.2h-1.7c-.22.74-.63,1.45-1.22,2.03-1.92,1.92-5.05,1.92-6.97,0l1.74-1.74h-4.65s0,4.65,0,4.65l1.74-1.74" />
  </>,
  "Cashback",
);

export default Icon;
